import { styled } from 'linaria/react'

export const Paragraph = styled.p`
  margin-left: 0.6rem;
  margin-bottom: 0.6rem;
  font-size: 0.95rem;
  letter-spacing: 0.02rem;
  text-indent: 1rem;
  line-height: normal;
`
